<template>
    <div class="x-md" v-if="aData.length>1">
        <h2>国际生比例</h2>
        <div class="pie">
            <canvas id="pie" ref="pieChart"></canvas>
        </div>
    </div>
</template>



<script setup>
import { Chart, ArcElement, Tooltip, Legend, PieController } from 'chart.js';
Chart.register(ArcElement, Tooltip, Legend, PieController);
// const data = ref({
//     name : "International House"
//     desc : "最大院校+拥有雅思考场，TOP级别的的英语学习体验。"
// });

const props = defineProps({
    data: Object
})
const rates = props.data.data.attributes.rate || [];
const aData = [];
const aNames = [];
let total = 0;
rates.forEach(element => {
    aNames.push(element.name+' '+element.rate+'%'),
    aData.push(element.rate);
    total += (+element.rate);
});
if(total < 100){
    aData.push(100-total);
    aNames.push('其他'+ ''+ (100-total)+'%');
}


const pieChart = ref(null);

onMounted(() => {
    if (pieChart.value && aData.length>1) {
        new Chart(pieChart.value, {
            type: 'pie',
            data: {
                labels: aNames,
                datasets: [{
                    data: aData,
                    backgroundColor: ['#F490F9', '#F9BF90','#C49AEF','#9AEFEF','#EF9A9A','#C4EF9A'],
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout : {
                    padding:{
                        left:0
                    }
                },
                // cutout: '70%',
                plugins: {
                    tooltip: {
                        enabled: true,
                    },
                    legend: {
                        display: true,
                        position:'right'
                    },
                },
            },
        });
    }

});

</script>


<style scoped>
.pie {
    max-width: 500px;
    height:300px; 
}
</style>